export default (function (_ref) {
  var request = _ref.request;
  return {
    projectKeyAdd: function projectKeyAdd(data) {
      return request({
        url: '/projectKey',
        method: 'post',
        data: data
      });
    },
    projectKeyDel: function projectKeyDel(id) {
      return request({
        url: "/projectKey/".concat(id),
        method: 'delete'
      });
    },
    projectKeyQuery: function projectKeyQuery(data) {
      return request({
        url: '/projectKey',
        method: 'get',
        params: data
      });
    }
  };
});